import { useParams, useSearchParams } from 'react-router-dom';
import ReservationWidget from '../components/widgets/ReservationWidget';

export default function WidgetPreview() {
  const { restaurantId } = useParams();
  const [params] = useSearchParams();
  const lang = params.get('lang') || 'es';
  const color = params.get('color') ? `#${params.get('color').replace('#','')}` : '#F97316';

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <ReservationWidget
        restaurantId={restaurantId}
        primaryColor={color}
        language={lang}
      />
    </div>
  );
}
